import React from 'react'
import styles from './styles.module.scss'
import { classNames } from '@/util/tailwindHelpers'

type Props = {
  className?: string
  min: number
  max: number
  value: number
  activeColorClass?: string
}

export default function Meter({
  className,
  value,
  min,
  max,
  activeColorClass
}: Props) {
  return (
    <div className={classNames('flex gap-[2.25%]', className)}>
      <meter className="sr-only" min={min} max={max} value={value} />

      {Array.from({ length: max }).map((_, index) => {
        return (
          <MeterValue
            key={index}
            className={classNames('transition-colors duration-300', {
              [`${activeColorClass}`]: value && index < value
            })}
          />
        )
      })}
    </div>
  )
}

const MeterValue = ({ className }) => {
  return (
    <div
      className={classNames(
        styles.meterValue,
        '@container relative flex-1 aspect-[5.41/14] text-gray-800',
        className
      )}
    />
  )
}
